import { render } from "./Show.vue?vue&type=template&id=0dde6b2d&scoped=true&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=0dde6b2d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0dde6b2d"

export default script